import { useRef } from 'react';
import Button from '../button';
import Dialog from '../../componentes/dialog';
import jsxArray from '../../utils/jsx-array';
import { ButtonToolbar } from 'reactstrap';
import { useIntl } from 'react-intl';

function MessageCancelEdit({
  title = 'label.confirmar',
  handleCancel,
  handleNaoSalvar,
  handleSave,
  ...dialogProps
}) {
  const intl = useIntl();
  const dialogRef = useRef(null);

  const handleCancelClick = () => {
    handleCancel?.();
    dialogRef.current?.close();
  };

  const handleNaoSalvarClick = () => {
    handleNaoSalvar?.();
    dialogRef.current?.close();
  };

  const handleSaveClick = () => {
    handleSave?.(true);
    dialogRef.current?.close();
  };

  const actions = jsxArray(
    <ButtonToolbar>
      <Button className="ml-2" onClick={handleCancelClick} color="default">
        {intl.formatMessage({ id: 'label.cancelar' })}
      </Button>
      <Button className="ml-2" color="danger" onClick={handleNaoSalvarClick}>
        {intl.formatMessage({ id: 'label.naoSalvar' })}
      </Button>
      <Button
        className="ml-2"
        autoFocus
        type="primary"
        onClick={handleSaveClick}
      >
        {intl.formatMessage({ id: 'label.salvar' })}
      </Button>
    </ButtonToolbar>
  );

  return (
    <Dialog
      {...dialogProps}
      width={440}
      ref={dialogRef}
      title={title}
      actions={actions}
      allowMaximize={false}
      padContent
    >
      {intl.formatMessage({ id: 'existeAlteracoesNaoSalvas' })}
    </Dialog>
  );
}

export default MessageCancelEdit;
